/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Rueckkauf { 
    tag: Rueckkauf.TagEnum;
    id: number;
    rueckkaufswert: number;
    rueckkaufswertDatum: string;
    praemienGuthaben: number;
    fondsvorauszahlung: number;
    darlehen: number;
    darlehenszins: number;
    ausstehendePraemien: number;
    ueberschuss: number;
    policennummer: string;
}
export namespace Rueckkauf {
    export type TagEnum = 'verzicht' | 'risikoversicherung-rueckkaufswert-0' | 'leibrentenpolice-rueckkaufswert-0' | 'fondpolice-rueckkaufswert-0';
    export const TagEnum = {
        VERZICHT: 'verzicht' as TagEnum,
        RISIKOVERSICHERUNG_RUECKKAUFSWERT_0: 'risikoversicherung-rueckkaufswert-0' as TagEnum,
        LEIBRENTENPOLICE_RUECKKAUFSWERT_0: 'leibrentenpolice-rueckkaufswert-0' as TagEnum,
        FONDPOLICE_RUECKKAUFSWERT_0: 'fondpolice-rueckkaufswert-0' as TagEnum
    };
}


